import React, { useContext, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import { AppActions } from 'store';
import { DispatchContext } from 'context';
import './main.css';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { Header } from 'app/header';
// import { BuscadorExterno } from 'app/buscador-externo';
import { Contacto } from 'app/contacto';
import { Footer } from 'app/footer';
import { SelectorTema } from 'app/selector-thema';
import { Element as SMElement, scroller } from 'react-scroll';
import { MessengerChat } from 'react-messenger-chat-plugin';
import { WhatsAppFloat } from 'components/whatsapp';
import Destino from 'app/paquetes/destino';

const Main2 = props => {
    // const scrollY = useScrollPosition(60);
    const dispatch = useContext(DispatchContext);
    // const state = useContext(StateContext);
    // const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    useEffect(() => {
        dispatch(AppActions.setLoading(false));
        dispatch(AppActions.setActionsDisabled(false));
        document.title = 'Servitravel.com.py';

    }, [dispatch]);

    const scrollear = (target) => {
        let offs = (target === 'inicio') ? 0 : -100;
        scroller.scrollTo(target, {
            duration: 1000,
            delay: 100,
            smooth: true,
            offset: offs, // Scrolls to element + 50 pixels down the page
        })
    }

    return (
        <div className="bs-bbox">
            <MessengerChat pageId='102483696457238' language='es_ES' />
            <SelectorTema/>
            <SMElement name="inicio">
                <Header scrollear={scrollear} paginaIndividual={true} />
            </SMElement>
                <Destino/>
            {/*  <SMElement name="galeria">
                <Galeria></Galeria>
            </SMElement> */}
            <SMElement name="contacto">
                <Contacto></Contacto>
            </SMElement>
            <WhatsAppFloat />
            <Footer />
            
        </div>
    );
}
export default withRouter(Main2);